import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { Users, MessageSquare, Mail, User, LogOut, GraduationCap, BookOpen, FileText, Video, ClipboardList, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    toast.success('Logged out successfully');
    navigate('/admin/login');
  };

  const menuItems = [
    { name: 'Homepage', path: '/admin/homepage', icon: Home },
    { name: 'Teachers', path: '/admin/teachers', icon: Users },
    { name: 'Courses', path: '/admin/courses', icon: BookOpen },
    { name: 'Test Series', path: '/admin/test-series', icon: FileText },
    { name: 'Videos', path: '/admin/videos', icon: Video },
    { name: 'Quizzes', path: '/admin/quizzes', icon: ClipboardList },
    { name: 'Testimonials', path: '/admin/testimonials', icon: MessageSquare },
    { name: 'Enrollments', path: '/admin/enrollments', icon: Mail },
    { name: 'Profile', path: '/admin/profile', icon: User },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-brand-surface">
      <nav className="bg-brand-dark text-white shadow-lg">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <GraduationCap className="h-6 w-6" />
            <span className="text-xl font-bold font-display">Tutor Flex Admin</span>
          </div>
          <Button
            data-testid="admin-logout-btn"
            onClick={handleLogout}
            variant="ghost"
            className="text-white hover:bg-slate-700"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Logout
          </Button>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row gap-6">
          <aside className="w-full md:w-64 bg-white rounded-xl p-4 shadow-sm h-fit">
            <nav className="space-y-2">
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`admin-nav-${item.name.toLowerCase()}`}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive(item.path)
                      ? 'bg-brand-blue text-white'
                      : 'text-slate-600 hover:bg-slate-100'
                  }`}
                >
                  <item.icon className="h-5 w-5" />
                  <span className="font-medium">{item.name}</span>
                </Link>
              ))}
            </nav>
          </aside>

          <main className="flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
